<template>
    <div class="content">
        <div class="tool">
            <el-button type="primary" class="el-icon-plus marg" @click="AddClick"> 新增</el-button>
            <el-input placeholder="请输入车场名称" v-model="searchForm.name" class="marg" style="width:150px"></el-input>
            <div v-if='User.user_type===0' class="tool marg">
                <label class="fn marg1">服务商</label>
                <el-select v-model="searchForm.ser_id" placeholder="请选择服务商">
                    <el-option label="无" :value="0"></el-option>
                    <el-option v-for="item in serDataList" :key="item.sp_id" :label="item.sp_name" :value="item.sp_id"></el-option>
                </el-select>
            </div>
            <div v-if='User.user_type===0||User.user_type===1||User.user_type===3' class="tool marg">
                <label class="fn marg1">运营商</label>
                <el-select v-model="searchForm.union_id" placeholder="请选择运营商">
                    <el-option label="无" :value="0"></el-option>
                    <el-option v-for="item in unionDataList" :key="item.up_id" :label="item.up_name" :value="item.up_id"></el-option>
                </el-select>
            </div>
            <el-button type="primary" class="el-icon-search marg" @click="FindClick"> 查询</el-button>
        </div>

        <!--车场列表-->
        <el-table :data='DataList' border stripe :highlight-current-row='true' max-height='calc(100vh - 220px)' height='calc(100vh - 220px)'>
           <el-table-column align="center" prop="pk_cloud_id" label="车场ID">
            <template slot-scope="scope">
              <span class="table-font">{{scope.row.pk_cloud_id}}</span>
            </template>
           </el-table-column>
            <el-table-column align="center" prop="pk_name" label="名称">
              <template slot-scope="scope">
                <span class="table-font">{{scope.row.pk_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="union_name" label="运营商">
              <template slot-scope="scope">
                <span class="table-font">{{scope.row.union_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="sericer_name" label="服务商">
              <template slot-scope="scope">
                <span class="table-font">{{scope.row.sericer_name}}</span>
              </template>
            </el-table-column>
             <el-table-column align="center" prop="pk_phone" label="联系方式">
              <template slot-scope="scope">
                <span class="table-font">{{scope.row.pk_phone}}</span>
              </template>
             </el-table-column>
            <el-table-column align="center" label="心跳时间">
              <template slot-scope="scope">
                <span class="table-font">{{FormData(scope.row.pk_heat_time)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="pk_cloud_ckey" label="车场秘钥">
              <template slot-scope="scope">
                <span class="table-font">{{scope.row.pk_cloud_ckey}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <div class="link_btn">
                        <el-link type="primary" @click="Edit(scope.row)">编辑</el-link>
                        <el-link type="warning" @click="EditUser(scope.row)">操作员</el-link>
                        <el-link type="primary" @click="CloudConfig(scope.row)">平台配置</el-link>
                        <el-link type="danger" @click="Restart(scope.row)">重启服务</el-link>
                        <el-link type="success" @click="QRCode(scope.row)">二维码</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="fy" layout="prev, pager, next" @current-change="current_change" :total="searchForm.total" background :page-size="searchForm.pageSize"></el-pagination>

         <!--车场信息-->
        <el-dialog :title="title" :visible.sync="dialogVisible" width='50%' :append-to-body='true'>
            <el-form :model="parkForm" :rules="rules" ref="parkForm" label-width="100px" size='medium'>
                <el-form-item label="车场名称" prop="pk_name">
                    <el-input v-model="parkForm.pk_name"></el-input>
                </el-form-item>
                <el-form-item v-if='User.user_type===0' label="所属服务商">
                    <el-select v-model="parkForm.pk_sp_id" style="width:100%;">
                        <el-option label="无" :value="0"></el-option>
                        <el-option v-for="item in serDataList" :key="item.sp_id" :label="item.sp_name" :value="item.sp_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if='User.user_type===0||User.user_type===1||User.user_type===3'  label="所属运营商">
                    <el-select v-model="parkForm.pk_up_id" style="width:100%;">
                        <el-option label="无" :value="0"></el-option>
                        <el-option v-for="item in unionDataList" :key="item.up_id" :label="item.up_name" :value="item.up_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="parkForm.pk_phone"></el-input>
                </el-form-item>
            </el-form>
            <baidu-map ak='GnVkZbGd47aleyQGoGScrNDTixMiT1Ui' v-if="dialogVisible" :center="parkForm.pk_lng!==0&&parkForm.pk_lng!==null?{lng: parkForm.pk_lng, lat: parkForm.pk_lat}:defaultCity" :zoom="11" :scroll-wheel-zoom="true" class="bm-view" style="height:300px" @click="MapClick">
                 <bm-marker v-if="parkForm.pk_lng!==0&&parkForm.pk_lng!==null" :position="{lng: parkForm.pk_lng, lat: parkForm.pk_lat}" >
                 </bm-marker>
            </baidu-map>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>

         <!--操作员-->
        <el-dialog v-if="userDialogVisible" :title="title" :visible.sync="userDialogVisible" width='50%' :append-to-body='true'>
            <SerUser :userType="5" :beglongId="parkId"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="userDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

         <!--平台配置-->
        <el-dialog v-if="cloudDialogVisible" :title="title" :visible.sync="cloudDialogVisible" width='40%' :append-to-body='true'>
            <el-form :model="parkForm" ref="parkForm" label-width="100px" size='medium'>
              <el-card>
                <div style="width:100%">
                  <span style="float:left;color:#36A4FF">支付平台</span>
                </div>
                <div style="margin-top:35px">
                  <el-form-item label="支付方式">
                    <el-select  v-model="parkForm.pk_pay_type" style="width:100%;">
                      <el-option label="PP支付(SDK)" :value="0"></el-option>
                      <el-option label="驰安" :value="1"></el-option>
                      <el-option label="乐刷" :value="2"></el-option>
                      <el-option label="泊链" :value="3"></el-option>
                      <el-option label="天涯行" :value="4"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="车场编号">
                      <el-input v-model="parkForm.pk_pay_id"></el-input>
                  </el-form-item>
                  <el-form-item label="车场秘钥">
                      <el-input v-model="parkForm.pk_pay_ckey"></el-input>
                  </el-form-item>
                  <el-form-item label="服务器地址" v-if="parkForm.pk_pay_type===null||parkForm.pk_pay_type===0">
                      <el-input v-model="parkForm.pk_pay_server"></el-input>
                  </el-form-item>
                </div>
              </el-card>
              <el-card>
                <div style="width:100%">
                  <span style="float:left;color:#36A4FF">ETC</span>
                </div>
                <div style="margin-top:35px">
                  <el-form-item label="车场 appid">
                      <el-input v-model="parkForm.pk_etc_appid"></el-input>
                  </el-form-item>
                </div>
              </el-card>
              <el-card>
                 <div style="width:100%">
                  <span style="float:left;color:#36A4FF">远程设置</span>
                </div>
                <div style="margin-top:35px">
                  <el-form-item label="识别码">
                      <el-input v-model="parkForm.pk_oray_id"></el-input>
                  </el-form-item>
                  <el-form-item label="验证码">
                      <el-input v-model="parkForm.pk_oray_pwd"></el-input>
                  </el-form-item>
                </div>
              </el-card>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cloudDialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>

          <!--车场二维码列表-->
          <el-dialog v-if="qrDialogVisible" :title="title" :visible.sync="qrDialogVisible" width='80%' :append-to-body='true'>
            <div>
              <el-button type="success" @click='AddQrcode'>新增二维码</el-button>
              <el-button type="success" @click='DownloadBatch'>批量下载</el-button>
            </div>
            <el-table :data='QrcodeDataList' ref="qrcodeTable" style="margin-top: 10px;" stripe :highlight-current-row='true'>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column align="center" prop="qr_type" label="二维码类型">
                <template slot-scope="scope">
                  <span class="table-font">{{scope.row.qr_type===0?'场内预付码':(scope.row.qr_type===1?'入口码':'出口码')}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="qr_gate_no" label="通道号">
                <template slot-scope="scope">
                  <span class="table-font">{{scope.row.qr_gate_no}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="qr_code" label="二维码url地址" width='350'>
                <template slot-scope="scope">
                  <span class="table-font">{{'https://parking.yundiankong.com/'+scope.row.qr_code}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="qr_create_time" label="创建时间">
                <template slot-scope="scope">
                  <span class="table-font">{{FormData(scope.row.qr_create_time)}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <div class="link_btn" style="display: flex;flex-direction: row;justify-content: start;align-items: center;">
                        <img src="../../assets/image/qrcode.png" style="cursor: pointer;height: 18px;width: 18px;margin-right: 10px;‌" @click='ShowQrCode(scope.row)'/>
                        <el-link type="primary" @click="EditQrcode(scope.row)">编辑</el-link>
                        <el-link type="warning" @click="Download(scope.row)">下载</el-link>
                        <el-link v-if='scope.row.qr_disable===1' type="primary" @click="Download(scope.row)">停用</el-link>
                        <el-link v-else type="danger" @click="Download(scope.row)">启用</el-link>
                    </div>
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="qrDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <el-dialog v-if="qrInfoDialogVisible" :title="title" :visible.sync="qrInfoDialogVisible" :width='showQrInfo?"900px":"450px"' :append-to-body='true'>
          <div style="display:flex;flex-direction: row;justify-content: space-around;align-items: center">
            <div v-show="showQrInfo" >
              <div>
                <el-radio v-model="qrForm.qr_type" :label="0">场内预付码</el-radio>
                <el-radio v-model="qrForm.qr_type" :label="1">入口码</el-radio>
                <el-radio v-model="qrForm.qr_type" :label="2">出口码</el-radio>
              </div>
              <div>
                <div class="qc">
                  <span class="t">背景色</span>
                  <div>
                    <el-radio v-model="qrForm.qr_color" :label="0">蓝色</el-radio>
                    <el-radio v-model="qrForm.qr_color" :label="1">红色</el-radio>
                  </div>
                </div>
                <div class="qc" v-if='qrForm.qr_type!==0'>
                  <span class="t">通道编号</span>
                  <el-input v-model="qrForm.qr_gate_no"  ></el-input>
                </div>
                <div class="qc">
                  <span class="t">联系电话</span>
                  <el-input v-model="qrForm.qr_phone"></el-input>
                </div>
                <div class="qc">
                  <span class="t">备注</span>
                  <el-input v-model="qrForm.qr_remark" type="textarea"></el-input>
                </div>
              </div>
            </div>
            <div>
              <span v-show="showQrInfo">二维码预览</span>
              <div :style="qrcodeStyle">
                <div style="font-size: 30px;margin-top: 10px">
                  <span v-if='qrForm.qr_type===0'>扫码预付 快速离场</span>
                  <span v-if='qrForm.qr_type===1'>无牌车扫码进场</span>
                  <span v-if='qrForm.qr_type===2'>扫码缴费离场</span>
                </div>
                <div style="margin-top: 10px;">
                  <span>{{parkForm.pk_name}}</span>
                </div>
                <VueQr :text="qrUrl" :size="250" :logoScale="0.2" style="margin-top: 10px;"></VueQr>
                <div style="width: 100%;display: flex;flex-direction: row;justify-content:space-around;margin-top: 10px;">
                  <div>
                    通道号：<span>{{qrForm.qr_gate_no}}</span>
                  </div>
                  <div>
                    联系方式：<span>{{qrForm.qr_phone}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button v-show="showQrInfo" type="primary" @click="Create">生 成</el-button>
              <el-button @click="qrInfoDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
import util from '../../util/util'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
import SerUser from '../../components/servicer/SerUser.vue'
import VueQr from 'vue-qr'
import JSZip from 'jszip'
import filesave from 'file-saver'
import html2canvas from 'html2canvas'


export default {
  data: function () {
    return {
      searchForm: {
        name: '',
        ser_id: 0,
        union_id: 0,
        pageSize: 15,
        pageNo: 1,
        total: 0
      },
      rules: {
        pk_name: [{ required: true, message: '请输入车场名称', trigger: 'blur' }]
      },
      User: null,
      DataList: [],
      serDataList: [],
      unionDataList: [],

      cityDataList:[],
      defaultCity:'北京',

      isReturn:true,

      title: '',
      dialogVisible: false,
      userDialogVisible: false,
      parkForm: {
        pk_id: 0,
        pk_name: '',
        pk_phone: '',
        pk_lng: 0,
        pk_lat: 0,
        pk_sp_id: 0,
        pk_up_id: 0,

        pk_pay_type:0,
        pk_pay_id: '',
        pk_pay_ckey: '',
        pk_pay_server: '',
        pk_oray_id: '',
        pk_oray_pwd: '',
        pk_etc_appid:''
      },
      parkId: 0,
      cloudDialogVisible: false,


      qrDialogVisible:false,
      QrcodeDataList:[],

      logoPath: require('../../assets/qrlogo.png'),
      qrInfoDialogVisible:false,
      qrForm:{
        qr_id:0,
        qr_park_id:0,
        qr_type:0,
        qr_gate_no:'',
        qr_code:'',
        qr_color:0,
        qr_phone:'',
        qr_remark:'',
        qr_disable:1
      },
      showQrInfo:true,
      qrUrl:'aaa',
    
    }
  },
  components: {
    BaiduMap,
    BmMarker,
    SerUser,
    VueQr
  },
  computed:{
    FormData () {
        return function (time) {
          if(time)
            return util.FormateDate(time, 2)
          else
            return ''
        }
    },
    qrcodeStyle(){
      return{
        backgroundColor:this.qrForm.qr_color===0?'#23A7D9':'#DD5A53',
        height: '400px',
        width: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white'
      }
    }
  },
  created () {
    this.GetDataList()
    this.User = util.JesToken()
  },
  methods: {
    GetDataList () {
      util.Get('parkmanage/getparkdatalist', this.searchForm).then(res => {
        if (res.rpStatus === 10000) {
            this.DataList = res.list[2]
            this.serDataList = res.list[0]
            this.unionDataList = res.list[1]
            this.searchForm.total = res.total
        }
      })
    },
    FindClick () {
      this.GetDataList()
    },
    MapClick (tp, target) {
      this.parkForm.pk_lng = tp.point.lng
      this.parkForm.pk_lat = tp.point.lat
    },
    current_change (page) {
      this.searchForm.pageNo = page
      this.GetDataList()
    },
    AddClick () {
      this.dialogVisible = true
      this.title = '新增'
      this.parkForm.pk_id = 0
      this.parkForm.pk_name = ''
      this.parkForm.pk_phone = ''
      this.parkForm.pk_lng = 0
      this.parkForm.pk_lat = 0
      this.parkForm.pk_sp_id = 0
      this.parkForm.pk_up_id = 0
      this.parkForm.pk_cloud_id = 0
      this.parkForm.pk_pay_type=0
      this.parkForm.pk_pay_id = ''
      this.parkForm.pk_pay_ckey = ''
      this.parkForm.pk_pay_server = ''
      this.parkForm.pk_oray_id = ''
      this.parkForm.pk_oray_pwd = ''
      this.parkForm.pk_etc_appid=''
    },
    Edit (row) {
      this.parkForm = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
      this.title = '修改'
    },
    submit () {
      if(this.isReturn){
        this.$refs.parkForm.validate((valid) => {
          if (valid) {
            this.isReturn=false
            util.Post('parkmanage/edit', this.parkForm).then(res => {
              if (res.rpStatus === 10000) {
                this.GetDataList()
                this.dialogVisible = false
                this.cloudDialogVisible = false
                this.$message.success('保存成功')
              } else { this.$message.error(res.rpMsg)}
              this.isReturn=true
            })
          }
        })
      }
      else{
        this.$message({message:'请稍后，正在处理中...',type: 'warning'})
      }
    },
    EditUser (row) {
      this.userDialogVisible = true
      this.title = '操作员'
      this.parkId = row.pk_id
    },
    CloudConfig (row) {
      this.cloudDialogVisible = true
      this.title = '平台配置'
      this.parkForm = JSON.parse(JSON.stringify(row))
    },
    Restart(row){
      this.parkForm = JSON.parse(JSON.stringify(row))
      util.Post('parkmanage/restart', this.parkForm).then(res => {
            if (res.rpStatus === 10000) {
              this.$message.success('重启车场服务成功') 
            } else { this.$message.error(res.rpMsg) }
      })
    },



    getQrcodeDataList(){
      util.Get('paycode/getdatalist?id='+this.qrForm.qr_park_id).then(res=>{
        if(res.rpStatus===10000){
          this.QrcodeDataList=res.list
        }
      })
    },

    QRCode(row){
      this.qrDialogVisible=true
      this.qrForm.qr_park_id=row.pk_id
      this.parkForm.pk_name=row.pk_name
      this.QrcodeDataList=[]
      this.getQrcodeDataList()
    },

    //新增二维码
    AddQrcode(){
      this.qrInfoDialogVisible=true
      this.qrForm.qr_id=0,
      this.qrForm.qr_type=0
      this.qrForm.qr_gate_no=''
      this.qrForm.qr_code=''
      this.qrForm.qr_color=0
      this.qrForm.qr_phone=''
      this.showQrInfo=true
    },
    EditQrcode(row){
      this.qrInfoDialogVisible=true
      this.qrForm.qr_id=row.qr_id
      this.qrForm.qr_park_id=row.qr_park_id
      this.qrForm.qr_type=row.qr_type
      this.qrForm.qr_gate_no=row.qr_gate_no
      this.qrForm.qr_code=row.qr_code
      this.qrForm.qr_color=row.qr_color
      this.qrForm.qr_phone=row.qr_phone
      this.showQrInfo=true
    },
    Create(){
      util.Post('paycode/edit',this.qrForm).then(res=>{
        if(res.rpStatus===10000){
          this.qrInfoDialogVisible=false
          this.getQrcodeDataList()
        }
        else{
          this.$message.error('保存失败')
        }
      })
    },


    ShowQrCode(row){
      this.qrInfoDialogVisible=true
      this.showQrInfo=false
      this.qrForm.qr_id=row.qr_id
      this.qrForm.qr_park_id=row.qr_park_id
      this.qrForm.qr_type=row.qr_type
      this.qrForm.qr_gate_no=row.qr_gate_no
      this.qrForm.qr_code=row.qr_code
      this.qrForm.qr_color=row.qr_color
      this.qrForm.qr_phone=row.qr_phone
      this.qrUrl='https://parking.yundiankong.com/'+row.qr_code
    },

    Disable(row){
      row.qr_disable=0
      util.Post('paycode/edit',row).then(res=>{
        if(res.rpStatus===10000){
          this.qrInfoDialogVisible=false
          this.getQrcodeDataList()
        }
        else{
          this.$message.error('保存失败')
        }
      })
    },

    
    Download(row){
      let arr=[]
      arr.push(row)
      this.down(arr)
    },
    //批量下载
    DownloadBatch(){
      var rows = this.$refs.qrcodeTable.selection
      //this.down(rows)
      console.log(rows)
    },

    down(rows){
      if (rows.length > 0) {
        var blogTitle = '二维码' // 图片压缩包名称
        var zip = new JSZip()
        var imgs = zip.folder(blogTitle)
        var baseList = [] // 需要压缩图片的路径
        var imgNameList = [] // 单张图片名称

        var arr = []

        for (var i = 0; i < rows.length; i++) {
         

        //   imgNameList.push((rows[i].qr_type===0?'场内预付码':(rows[i].qr_type===1?'入口码':'出口码'))+rows[i].qr_gate_no)
        //   const image = new Image()
        //   // 生成二维码
        //   arr.push('https://parking.yundiankong.com/'+rows[i].qr_code)
        //   image.src = 'https://parking.yundiankong.com/'+rows[i].qr_code
          
        //   var canvas = document.createElement('canvas') // 准备空画布
        //   canvas.width = 300
        //   canvas.height = 300
        //   canvas.id='aa'
        //   var context = canvas.getContext('2d')

        //   image.onload = function () {
        //     context.drawImage(image, 0, 0, 300, 300)
            
        //     const url = canvas.toDataURL()
        //     canvas.toDataURL('image/png')
        //     baseList.push(url.substring(22)) // 去掉base64编码前的 data:image/png;base64,
            
        //     if (baseList.length === arr.length && baseList.length > 0) {
        //       for (let k = 0; k < baseList.length; k++) {
        //         imgs.file(imgNameList[k] + '.png', baseList[k], { // 设置单张图片名称
        //           base64: true
        //         })
        //       }
        //       zip.generateAsync({
        //         type: 'blob'
        //       }).then(function (content) {
        //         // 调用 FileSaver.js
        //         filesave.saveAs(content, blogTitle + '.zip')
        //       })
        //     }
        //     image.src = arr[i]
        //   }
        }
        } else {
          this.$message.error('请选择要下载的二维码')
        }
      }


  }
}
</script>

<style scoped>
  @import '../../assets/css/font.css';
.tool{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.marg{
    margin-right: 20px;
}
.marg1{
    margin-right: 10px;
}
.el-table{
    margin-top: 15px;
}
.fn{
    font-size: 13px;
}
.el-link{
    margin-right: 10px;
    font-size: 11px;
}
.card{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
::v-deep .el-dialog{
  --el-bg-color:#000741 !important;
}
::v-deep .el-dialog__header{
  --el-text-color-primary:#1effff;
  --el-text-color-regular:#fff;
  padding: 0px !important;
  background-color: #309CE2;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__title{
    color: white;
}

::v-deep .el-dialog__headerbtn .el-dialog__close{
    color: white;
} 



.qc{
  margin-top: 20px;
}

.qc div{
  margin-top: 10px;
}

.t{
  font-size: 18px;
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
}




</style>
